import "core-js/modules/web.dom.iterable";
import _regeneratorRuntime from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getImgList as _getImgList, queryOverprintPlate } from '@/api/queryTemplate';
// import ProcessPlate from "@/pages/pdm/components/processPlate"
// import PersonalInfo from "@/pages/pdm/components/personalInfo"
// import ContactInfo from "@/pages/pdm/components/contactInfo"
// import CheckSku from "@/pages/pdm/components/checkSku"
export default {
  name: 'OpTableContentFilter',
  components: {},
  props: {
    options: {
      type: Object,
      required: true,
      default: function _default() {
        return {
          tableHead: [],
          currHeaeItem: {},
          currRow: {}
        };
      }
    }
  },
  data: function data() {
    return {
      // theads所有动态表头数据
      // currHeaeItem当前表头数据
      // currRow,当前行数据
      imgList: [],
      processPlateList: [],
      showImgVisible: false,
      gridData: [],
      type1: "",
      personalInfo: {},
      contactInfo: {
        supplierAddress: "",
        primaryContact: "",
        contactMobile: ""
      },
      skuList: [],
      type2: [],
      type3: [],
      type4: "",
      pos: 0,
      spanArr: []
    };
  },
  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      _this.init();
    });
  },
  methods: {
    // 套版信息
    getProcessPlateList: function () {
      var _getProcessPlateList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(id) {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return queryOverprintPlate(id);
            case 2:
              result = _context.sent;
              if (result.code === 200) {
                this.processPlateList = result.data.list;
              }

              // processPlateList
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getProcessPlateList(_x) {
        return _getProcessPlateList.apply(this, arguments);
      }
      return getProcessPlateList;
    }(),
    getImgList: function () {
      var _getImgList2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(colorId) {
        var result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.showImgVisible = true;
              _context2.next = 3;
              return _getImgList(colorId);
            case 3:
              result = _context2.sent;
              if (result.code === 200) {
                this.imgList = result.data;
              }
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getImgList(_x2) {
        return _getImgList2.apply(this, arguments);
      }
      return getImgList;
    }(),
    getSimilarModels: function getSimilarModels(designNo) {
      console.log(designNo);
    },
    init: function init() {
      var _this2 = this;
      if (this.options.currHeaeItem.fieldType === "1") {
        this.type1 = this.options.currRow[this.options.currHeaeItem.fieldCode];
      }
      if (this.options.currHeaeItem.fieldType === "2") {
        var keys = [];
        this.options.tableHead && this.options.tableHead.length > 0 && this.options.tableHead.forEach(function (item) {
          if (item.bindField === _this2.options.currHeaeItem.fieldCode) {
            item.text = _this2.options.currRow[item.fieldCode];
            keys.push(item);
          }
        });
        this.type2 = keys;
      }
      if (this.options.currHeaeItem.fieldType === "3") {
        var _keys = [];
        this.options.tableHead && this.options.tableHead.length > 0 && this.options.tableHead.forEach(function (item) {
          if (item.bindField === _this2.options.currHeaeItem.fieldCode) {
            _keys.push(item);
          }
        });
        this.type3 = _keys.map(function (item) {
          // item.text = this.options.currRow[item.fieldCode]
          return item;
        });
      }
      if (this.options.currHeaeItem.fieldType === "4") {
        this.type4 = this.options.currRow[this.options.currHeaeItem.fieldCode];
      }
    }
  }
};